export type WorkflowDefinition<T extends string, S extends string> = Readonly<
  Record<T, { from: S | readonly S[]; to: S }>
>;

const toArray = (value: string | readonly string[]): string[] => {
  return Array.isArray(value) ? value : [value];
};

export type WorkflowState<D extends WorkflowDefinition<string, string>> =
  D[keyof D]['to'];

export const createWorkflow = <T extends string, S extends string>(
  definition: WorkflowDefinition<T, S>,
  defaultState: WorkflowState<typeof definition>
) => {
  let currentState = defaultState;

  const apply = (name: T) => {
    const transition = definition[name];

    if (!toArray(transition.from).includes(currentState)) {
      throw new Error(
        `Cannot transition from ${currentState} to ${transition.to}`
      );
    }

    currentState = transition.to;

    return currentState;
  };

  return {
    apply,
    getState: () => currentState,
  };
};
